import type { NetworkPayload } from "../../../composites";

const getSubmissionPath = (submissionId: API.NachaPassthrough.SubmissionId) =>
  `ach_nacha_passthrough/${encodeURIComponent(String(submissionId))}/`;

export const API = {
  fetchNachaPassthroughSubmission: (
    submissionId: API.NachaPassthrough.SubmissionId,
  ): NetworkPayload => ({
    url: getSubmissionPath(submissionId),
    options: {
      method: "GET",
    },
  }),

  fetchNachaPassthroughEntries: (
    submissionId: API.NachaPassthrough.SubmissionId,
    offset: number,
    limit: number,
    search?: string,
  ): NetworkPayload => {
    const params = new URLSearchParams({
      limit: String(limit),
      offset: String(offset),
    });
    if (search) params.set("search", search);

    return {
      url: `${getSubmissionPath(submissionId)}entries/?${params}`,
      options: {
        method: "GET",
      },
    };
  },

  cancelNachaPassthroughSubmission: (
    submissionId: API.NachaPassthrough.SubmissionId,
  ): NetworkPayload => ({
    url: `${getSubmissionPath(submissionId)}cancel/`,
    options: {
      method: "PUT",
      payload: {},
    },
  }),
};
